import { Component, Input, OnInit } from '@angular/core';
import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { TransactionService } from 'src/app/pages/transaction-admin/services/transaction.service';
import { TransactionService as TransactionUserService } from 'src/app/pages/transaction/services/transaction.service';
import { TransactionExternalService } from 'src/app/pages/transaction/services/transaction-external.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { Router, ActivatedRoute } from '@angular/router';
import { TransactionRequirementItemServiceService } from 'src/app/pages/transaction/services/transaction-requirement-item.service';
import { Subscription } from 'rxjs';
import { TransactionRevisionExternalService } from 'src/app/pages/transaction/services/transaction-revision-status-external.service';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';

/**
 * PdfForm ciudadano: mismo patrón que la rama de referencia — [formData] en ngx,
 * carga desde showFile (getPdf + PdfFormJson filtrado), guardado POST /file con blob + pdfFormJson.
 */
@Component({
	selector: 'pdf-viewer',
	templateUrl: './pdf-viewer.component.html',
	styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent extends BaseManagement implements OnInit {
	@Input() validateForm = false;
	requirement: any;
	serverError: any = '';
	pdfSrc: any;
	requirementItem: any;
	itemToEdit: any = { Id: null };
	minimize: boolean = false;
	subscriptions: Subscription[] = [];
	revisionStatusLog: any = {};
	public downloaded: string | undefined;

	isFormValid: boolean = false;
	formData: any = null;
	private pdfFieldsDebugTimer: any = null;

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public mainService: TransactionRequirementService,
		public ngxService: NgxExtendedPdfViewerService,
		public transactionService: TransactionService,
		public transactionExternalService: TransactionExternalService,
		public translate: TranslateService,
		public transactionRequirementItemServiceService: TransactionRequirementItemServiceService,
		public transactionRevisionExternalService: TransactionRevisionExternalService,
		public transactionUserService: TransactionUserService
	) {
		super();

		this.mainService.pdfCommunicator.subscribe((data) => {
			if (data === 'save-data') {
				this.tryDownloadAsBlob('submit-for-review');
			}
		});
	}

	ngOnInit() {
		this.requirementItem =
			this.transactionRequirementItemServiceService.requirementItem;

		this.pdfSrc = this.mainService.fileToLoad;

		const params: any = {};
		params.userProcessId = this.requirementItem.ProcessId;
		params.requirementId = this.requirementItem.RequirementId;

		this.transactionRevisionExternalService
			.getRevisionStatusLog(params)
			.then((data: any) => {
				this.revisionStatusLog = {
					CompletedDate: 'n/a',
					RemediedDate: 'n/a'
				};
				if (data) {
					this.revisionStatusLog = data;
				}
				this.validateRequiredFields();
			})
			.catch((err) => {
				console.log('error', err);
				this.serverError =
					'An error ocurred when getting the revision status log.';
			});
	}

	validateRequiredFields(): boolean {
		const formData: any = this.mainService.formData;

		const requiredFieldsObject: any = {};

		if (formData && typeof formData === 'object') {
			for (const propertyName in formData) {
				if (propertyName.toLowerCase().includes('required')) {
					requiredFieldsObject[propertyName] = formData[propertyName];
				}
			}
		}

		for (const propertyName in requiredFieldsObject) {
			const value = requiredFieldsObject[propertyName];
			if (value === '' || value === null || value === undefined) {
				this.isFormValid = false;
				return false;
			}
		}

		this.isFormValid = true;
		return true;
	}

	ngOnDestroy() {
		if (this.pdfFieldsDebugTimer) {
			clearTimeout(this.pdfFieldsDebugTimer);
			this.pdfFieldsDebugTimer = null;
		}
		this.subscriptions.forEach((s) => s.unsubscribe());
	}

	/**
	 * Tras clic en "Mostrar Formulario" (showFile): lista campos del PDF abierto en consola
	 * cuando el visor termina de cargar (getFormData + DOM .annotationLayer).
	 */
	onCitizenPdfPagesLoaded(): void {
		if (!this.mainService.logPdfAcroFieldsAfterCitizenOpen) {
			return;
		}
		this.mainService.logPdfAcroFieldsAfterCitizenOpen = false;
		if (this.pdfFieldsDebugTimer) {
			clearTimeout(this.pdfFieldsDebugTimer);
		}
		this.pdfFieldsDebugTimer = setTimeout(() => {
			this.pdfFieldsDebugTimer = null;
			this.logPdfAcroFieldsToConsole();
		}, 900);
	}

	private async logPdfAcroFieldsToConsole(): Promise<void> {
		try {
			const rawFields: any[] = await this.ngxService.getFormData();
			const rows = (rawFields || []).map((f: any) => {
				const a = f.fieldAnnotation;
				const hints: string[] = [];
				if (!a) {
					hints.push('sin fieldAnnotation');
				} else {
					if (a.checkBox) {
						hints.push('checkbox');
					}
					if (a.radioButton) {
						hints.push('radio');
					}
					if (a.comboBox) {
						hints.push('combo');
					}
					if (a.textInput || (a.value !== undefined && !a.checkBox)) {
						hints.push('text');
					}
				}
				let val = '';
				if (a) {
					if (typeof a.isChecked === 'boolean') {
						val = a.isChecked ? 'true' : 'false';
					} else if (a.checkBox && typeof a.checkBox.isChecked === 'boolean') {
						val = a.checkBox.isChecked ? 'true' : 'false';
					} else if (a.value != null) {
						val = String(a.value);
					}
				}
				return {
					name: f.name,
					tipo: hints.length ? hints.join(',') : '?',
					valor: val,
				};
			});
			console.groupCollapsed(
				`[Mostrar formulario / PDF] AcroForm — getFormData: ${rows.length} campo(s)`
			);
			console.table(rows);
			console.log('getFormData() raw:', rawFields);

			const domEls = document.querySelectorAll(
				'.annotationLayer input, .annotationLayer textarea, .annotationLayer select'
			);
			const domRows: { name: string; tag: string; type: string; disabled: boolean }[] = [];
			domEls.forEach((node) => {
				const el = node as HTMLInputElement;
				const nm = (el.name || '').trim() || el.id || '(sin name)';
				domRows.push({
					name: nm,
					tag: el.tagName,
					type: el.type || '-',
					disabled: !!el.disabled,
				});
			});
			console.log(`DOM .annotationLayer: ${domRows.length} control(es)`);
			console.table(domRows);

			const ngxNames = new Set(
				rows.map((r) => r.name).filter((n) => n != null && String(n).length > 0)
			);
			const domNames = new Set(
				domRows.map((r) => r.name).filter((n) => n !== '(sin name)')
			);
			const onlyNgx = [...ngxNames].filter((n) => !domNames.has(n));
			const onlyDom = [...domNames].filter((n) => !ngxNames.has(n));
			if (onlyNgx.length || onlyDom.length) {
				console.warn(
					'Diferencia de nombres — solo en getFormData:',
					onlyNgx,
					'solo en DOM:',
					onlyDom
				);
			}
			console.groupEnd();
		} catch (e) {
			console.warn('[Mostrar formulario / PDF] No se pudo listar campos AcroForm:', e);
		}
	}

	trySubmitForReview(action) {
		if (this.isSaving()) {
			return;
		}

		this.mainService.pdfCommunicator.next('save-data');
	}

	minimizeRevisionAlert(action) {
		this.minimize = false;
		if (action === true) {
			this.minimize = true;
		}
	}

	close() {
		this.translate
			.get([
				'message.deleteConfirmText',
				'message.yes',
				'message.no',
				'message.requirement',
				'message.deleted',
				'message.unableRequirement',
				'message.done',
				'pdfform.closeWarn',
			])
			.subscribe((translations) => {
				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['pdfform.closeWarn'],
						yesText: translations['message.yes'],
						noText: translations['message.no'],
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 1) {
						this.mainService.fileToLoad = null;
						this.transactionUserService.transactionRefresher.next(
							'refresh-all'
						);
					}
				});
			});
	}

	tryDownloadAsBlob(action) {
		if (!this.isFormValid) {
			this.alertCompleteForm();
			return;
		}

		if (this.isSaving()) {
			return;
		}

		this.translate
			.get([
				'message.deleteConfirmText',
				'message.yes',
				'message.no',
				'message.requirement',
				'message.deleted',
				'message.unableRequirement',
				'message.done',
				'pdfform.saveWarn',
			])
			.subscribe((translations) => {
				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['pdfform.saveWarn'],
						yesText: translations['message.yes'],
						noText: translations['message.no'],
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 1) {
						this.startSaving(action);
						this.downloadAsBlob(action);
					}
				});
			});
	}

	public async downloadAsBlob(action): Promise<void> {
		const blob = await this.ngxService.getCurrentDocumentAsBlob();
		if (!blob) {
			this.downloaded = 'download failed';
			this.stopSaving();
			return;
		}

		this.downloaded = 'The BLOB contains ' + blob.size + ' byte.';

		const formData = new FormData();
		const filePdf = new File([blob], 'name.pdf');
		formData.append('file', filePdf);

		formData.append('id', this.mainService.UserProcessRequirementId);
		formData.append('processId', this.mainService.ProcessId);

		const sanitizedFormData = this.convertNewLinesToHtml(
			this.mainService.formData
		);
		formData.append('pdfFormJson', JSON.stringify(sanitizedFormData));

		formData.append('fileName', this.mainService.FileName);

		this.mainService
			.uploadRequirementFile(formData)
			.then((updatedRequirement) => {
				this.mainService.pdfCommunicator.next('stop-saving');

				this.requirement = updatedRequirement;

				this.mainService.updateItemByField(
					this.requirement.UserProcessRequirementId,
					'UserProcessRequirementId',
					this.requirement
				);

				this.transactionService
					.getTimeline(this.requirement.ProcessId)
					.then(() => {
						this.mainService.fileToLoad = null;
						this.transactionUserService.transactionRefresher.next(
							'refresh-all'
						);
					});
				this.stopSaving();
			})
			.catch((err) => {
				console.log('error', err);
				this.translate
					.get(['error.documentUplaod'])
					.subscribe(() => {
						this.stopSaving();
						this.serverError =
							'Hubo un problema al intentar enviar el documento';
					});
			});
	}

	onFormChange(event: any) {
		if (this.validateForm) {
			this.validateRequiredFields();
		} else {
			this.isFormValid = true;
		}
	}

	alertCompleteForm() {
		const dialogRef = this.dialog.open(DialogOkComponent, {
			data: {
				msg: 'Rellene todos los campos obligatorios.',
			}
		});

		dialogRef.afterClosed().subscribe((res: any) => {});
	}

	private convertNewLinesToHtml(data: any): any {
		const converted: any = {};

		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				let value = data[key];

				if (typeof value === 'string') {
					value = value.replace(/\r\n/g, '\n');
					value = value.replace(/\r/g, '\n');
					value = value.replace(/\n/g, '<br>');
				}

				converted[key] = value;
			}
		}

		return converted;
	}
}
